const baseUrl = "/v1/admin/activity";

export const apiUrls = {
  list: `${baseUrl}`,
  details: (id: number): string => `${baseUrl}/${id}/details`,
};
